import React from "react";
import { Home } from "./Views";

function App() {
  return <Home />;
}

export default App;
